import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { Stack } from 'syf-component-library/ui/spacing';
import Link from 'syf-component-library/ui/atoms/Link';
import query from 'syf-component-library/const/mediaQueries';
import { t } from '../../translations/getTranslation';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { Paragraph } from '../../components/Styled/typography';
import useAccountSummary from '../../hooks/useAccountSummary';
import useAnalytics from '../../hooks/useAnalytics';
import CardInfo from '../../components/cards/CardInfo';
import { contactNumber } from '../../const/customerCareNumber';
const FraudWrapper = styled.p `
  background-color: ${({ theme }) => theme.colors.greyNinetyEight};
  border: 1px solid ${({ theme }) => theme.colors.lightestGrey};
  padding: ${({ theme }) => theme.spacing.base}px;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes.regular}px;
`;
const BoldText = styled.span `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;
const FraudLink = styled(Link) `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  justify-content: left;
  padding: 0;
  margin-bottom: ${({ theme }) => theme.spacing.medium}px;
  height: fit-content;
`;
const ContactNumberLink = styled(Link) `
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  padding: 0;
  display: inline;

  @media ${query.greaterThanMedium} {
    font-weight: ${({ theme }) => theme.fontWeights.regular};
    color: inherit;
    pointer-events: none;
    text-decoration: none;
  }
`;
const TempBlockWithNumber = () => {
    const { isSuccess, isSemu } = useAccountSummary();
    const fraudUrl = 'https://www.synchrony.com/legal/fraud-protection';
    useAnalytics(isSuccess, { isSemu });
    return (_jsxs(_Fragment, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, { title: t('tempBlock.yourAccount'), modalImageProps: { imageName: 'CONTACT_REP' } }), _jsxs(Paragraph, { children: [t('tempBlock.forYourProtection'), _jsx(ContactNumberLink, Object.assign({ href: `tel:${contactNumber}` }, { children: contactNumber })), t('tempBlock.soWeCanReview')] }), _jsx(Stack, { size: "xxlarge" }), _jsx(FraudLink, Object.assign({ href: fraudUrl }, { children: t('tempBlock.fraudPrevention') })), _jsxs(FraudWrapper, { children: [_jsx(BoldText, { children: t('tempBlock.fraudLiabilityBold') }), '. ', t('tempBlock.fraudLiability')] })] }))] }));
};
export default TempBlockWithNumber;
//# sourceMappingURL=index.js.map